export class AdminBoxQuestionnaireContextOperations {
  public constructor(
    private readonly data: {
      canBeResumed: boolean;
      canBeEnded: boolean;
      canBeViewed: boolean;
      canBeSelectionChanged: boolean;
    },
  ) {}

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeResumed(): boolean {
    return this.data.canBeResumed;
  }

  public get canBeEnded(): boolean {
    return this.data.canBeEnded;
  }

  public get canBeSelectionChanged(): boolean {
    return this.data.canBeSelectionChanged;
  }
}
